import React, { useEffect, createElement } from 'react';
import { Testimonials } from '../components/Testimonials';
export function Cases() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-149">
      <div className="pt-24 pb-12 px-6 md:px-12" style={{
      backgroundColor: '#F7F5F0'
    }} data-id="element-150">
        <div className="max-w-6xl mx-auto text-center" data-id="element-151">
          <div className="inline-block bg-white rounded-full px-8 py-3 mb-6" data-id="element-152">
            <p className="font-display text-lg md:text-xl font-medium text-navy/70" data-id="element-153">
              New ✨ For Immigration Firms Seeking More Talent Visa Cases
            </p>
          </div>
          <h1 className="font-display text-4xl md:text-6xl font-bold mb-6 text-navy" data-id="element-154">
            We'll Guarantee Qualified Cases For Talent Visas - And You Only Pay
            For Results
          </h1>
          <p className="text-xl text-navy/80 max-w-3xl mx-auto mb-8" data-id="element-155">
            No Retainers. No Website Required. No Advertising Expense.
          </p>
          <div id="application-form" data-tf-live="01JK0WQ1E8T2V7NGQ32NZ4CHBZ" data-id="element-156"></div>
          <div className="mt-12 flex flex-wrap justify-center items-center gap-8 md:gap-12 text-navy/70" data-id="element-157">
            <div className="flex items-center gap-2" data-id="element-158">
              <span className="text-2xl" data-id="element-159">•</span>
              <span className="text-sm md:text-base" data-id="element-160">
                Trusted by 50+ Immigration & Law Firms
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-161">
              <span className="text-2xl" data-id="element-162">•</span>
              <span className="text-sm md:text-base" data-id="element-163">
                4.9/5 Client Satisfaction
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-164">
              <span className="text-2xl" data-id="element-165">•</span>
              <span className="text-sm md:text-base" data-id="element-166">
                Industry-Leading Results
              </span>
            </div>
          </div>
        </div>
      </div>
      <Testimonials data-id="element-167" />
    </div>;
}